import React from "react";

// Material UI imports
import {
    CardActionArea,
    Typography,
    Tooltip,
    CardContent,
} from "@material-ui/core";

// Component imports
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardTitle from "components/Card/CardTitle";
import CardFooter from "components/Card/CardFooter.js";

// Material UI icon imports
import CheckIcon from "@material-ui/icons/Check";
import CloseIcon from "@material-ui/icons/Close";
import { makeStyles } from "@material-ui/core/styles";
import { Launch } from "@material-ui/icons";

// Custom component imports
import Button from "components/CustomButtons/Button";


const useStyles = makeStyles((theme) => ({

}));


export default function ActualCard({ title, description, image, id, toolboxType }) {
    const CARD_STATUS = "Created";
    const styles = useStyles();
    const getStatusIcon = (status) => {
        switch (status) {
            case "Created":
                return <CheckIcon />;
            case "Inactive":
                return <CloseIcon />;
            default:
                return <CheckIcon />;
        }
    };
    const onLaunch = () => {

        switch (toolboxType) {
            case "PODCAST":
                // /podcastdesign/podcast/
                window.open(`/create/podcastdesign/podcast/${id}`, "_blank");
                break;
            case "COURSE":
                // /course-design/courses/:courseID/
                window.open(`/create/course-design/courses/${id}`, "_blank");
                break;
            case "CONCEPT_LABS":
                // /labdesign/lab/:labID
                window.open(`/create/labdesign/lab/${id}`, "_blank");
                break;
            case "CASE_STUDY":
                // /case_study/:caseStudyID
                window.open(`/create/case_study/${id}`, "_blank");
                break;
            case "HANDOUT":
                // /handout/:writingId
                window.open(`/create/handout/${id}`, "_blank");
                break;
            case "RESEARCH_REPORT":
                // /research_report/:writingId  
                window.open(`/create/research_report/${id}`, "_blank");
                break;
            case "KEY_INSIGHTS":
                // /key_insights/:writingId
                window.open(`/create/key_insights/${id}`, "_blank");
                break;
            case "BLOG":
                // /blog/:writingId
                window.open(`/create/blog/${id}`, "_blank");
                break;
            case "WHITEPAPER":
                // /white_paper/:writingId
                window.open(`/create/white_paper/${id}`, "_blank");
                break;
            case "PROJECT_PLAN":
                // /project_plan/:writingID
                window.open(`/create/project_plan/${id}`, "_blank");
                break;
            case "NEWSLETTER":
                // /news_letter/:writingID
                window.open(`/create/news_letter/${id}`, "_blank");
                break;
            case "MODEL_DEVELOPMENT":
                // /model_development/model/:projectId
                window.open(`/create/model_development/model/${id}`, "_blank");
                break;
            case "MODEL_VALIDATION":
                // /model_validation/model/:projectId
                window.open(`/create/model_validation/model/${id}`, "_blank");
                break;
            case "PROJECT":
                // /project-design/projects/:projectID
                window.open(`/create/project-design/projects/${id}`, "_blank");
                break;
            case "FORM":
                // /form-design/:formId
                window.open(`/create/form-design/${id}`, "_blank");
                break;
            case "SESSION":
                // /sessions/session/:sessionId
                window.open(`/create/sessions/session/${id}`, "_blank");
                break;
            default:
                return;
        }
    };
    const images = require.context("assets/img/create_cards_16_9", true);
    return (
        <Card
            elevation={3}
            style={{
                marginTop: 40,
                borderRadius: 12,
                background: 'rgba(255, 255, 255, 0.95)',
                color: '#20677b',
                cursor: 'pointer',
                maxWidth: '40%',
            }}
            onClick={onLaunch}
        >
            <CardActionArea>
                <CardHeader icon text>
                    <CardTitle color="quCreateColor">{title}</CardTitle>
                </CardHeader>

                <CardContent>
                    <Typography
                        variant="body2"
                        style={{
                            color: '#20677b',
                            minHeight: '100px',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            display: '-webkit-box',
                            WebkitLineClamp: 3,
                            WebkitBoxOrient: 'vertical',
                        }}
                    >
                        {description}
                    </Typography>
                </CardContent>
            </CardActionArea>

            <CardFooter stats style={{ marginTop: 0, paddingBottom: 10, borderTop: '1px solid #20677b' }}>
                <div style={{ display: 'flex', width: '100%', justifyContent: 'space-between', alignItems: 'center' }}>
                    {/* Status (left) */}
                    <Tooltip title={CARD_STATUS} arrow>
                        <Typography
                            variant="body2"
                            style={{
                                color: '#20677b',
                                whiteSpace: 'nowrap',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                maxWidth: '100%',
                                alignItems: 'center',
                                gap: 8,
                            }}
                        >
                            {getStatusIcon(CARD_STATUS)} {CARD_STATUS}
                        </Typography>
                    </Tooltip>
                    {/* No right-side buttons per request */}
                </div>
                {/* Create (right) */}
                <Button
                    variant="contained"
                    style={{ background: '#20677b', color: '#fff' }}
                    onClick={(e) => {
                        e.stopPropagation(); // prevent the Card's onClick from firing
                        onLaunch();
                    }}
                >
                    Launch
                </Button>
            </CardFooter>
        </Card>
    );
}